<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import type { Block } from './block'

defineProps<{ block: Block<'prompt'> }>()
</script>

<template>
  <div class="ai-block-prompt">{{ block.text }}</div>
</template>

<style scoped>
.ai-block-prompt {
  width: fit-content;
  max-width: 85%;
  margin-left: auto;
  padding: var(--dimension-4) var(--dimension-5);
  border-radius: var(--border-radius);
  background-color: var(--default-form-element-bg-color);
  font-size: var(--font-size-normal);
  line-height: var(--dimension-7);
  letter-spacing: 0;
  color: var(--font-color-strong);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
